/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetLastSuccessfulLoginRequest} from '@cash-web/protos/squareup/cash/janus/api/JanusService.pb'
import {GetLastSuccessfulLoginResponse} from '@cash-web/protos/squareup/cash/janus/api/JanusService.pb'


export const getLastSuccessfulLogin = (request:GetLastSuccessfulLoginRequest, options?: CashRequestOptions) => post<GetLastSuccessfulLoginRequest, GetLastSuccessfulLoginResponse>("/2.0/cash/get-last-successful-login", request, {...options, rejectOnError: true })